<template>
<div class="col backgroundForm">
    <div class="col-md-6 offset-md-3">
        <div class="alert alert-info" align="center" role="alert">
            <h4 class="alert-heading">UFV</h4>
            <p>Registro y listado de valor de la UFV</p>        
        </div>        
    </div>
    <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <a class="nav-item nav-link active" id="nav-ufv-new" data-toggle="tab" href="#new-ufv" role="tab" aria-controls="nav-capitan" aria-selected="true"><font-awesome-icon icon="plus" /> Registro UFV</a>
            <a class="nav-item nav-link" id="nav-add-capitan" data-toggle="tab" href="#list-ufv" role="tab" aria-controls="nav-new" aria-selected="false"><font-awesome-icon icon="list" /> Listado de UFV</a>
        </div>
    </nav>

    <div class="tab-content" id="nav-tabContent">                
        <div class="tab-pane fade show active" id="new-ufv" role="tabpanel" aria-labelledby="nav-capitan-tab">
            <br>
            <h5 align="center">Registro de la UFV</h5>
            <div class="form-row">
                <div class="form-group col-12 col-md-3 offset-md-3" >
                    <label for="new-value">UFV</label>
                    <input type="number" v-model="ufv.value" name="new-value" id="new-value" class="form-control" autocomplete="off">
                </div>
                <div class="form-group col-12 col-md-3" >
                    <label for="date-value">Fecha del Valor UFV</label>
                    <datetime  v-model="ufv.date" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha Valor UFV" value-zone="America/La_Paz" ></datetime>
                </div>
            </div>

            <button class="btn btn-danger col-12 col-md-2 offset-md-5" @click="mSendUFV"><font-awesome-icon icon="save" size="2x" /></button>            
        </div>
        <!-- end first tab -->

        <div class="tab-pane fade" id="list-ufv" role="tabpanel" aria-labelledby="nav-capitan-tab">
            
            <br>
            <h5 align="center">Listado de UFV</h5>
            <div class="form-row">
                <div class="form-group col-12 col-md-4 offset-md-4">
                    <label for="number_register">Numero de Registros a Listar</label>
                    <input type="number" v-model="ufv_list" name="new-value" id="new-value" class="form-control" autocomplete="off">
                </div>
            </div>
            <button class="btn btn-info col-12 col-md-2 offset-md-5" @click="mListUfv"><font-awesome-icon icon="list" size="2x" /></button>

            <br><br>
            <transition name="fade" mode="out-in">
                <div class="table-responsive col-12 col-md-6 offset-md-3" v-if="dts_ufv.length > 0">
                    <table class="table table-hover">
                        <thead class="thead-dark">
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Valor</th>
                                <th scope="col">Fecha</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(du, key) in dts_ufv " :key="key">
                                <th scope="col">{{ key+1 }}</th>
                                <td>{{ du.value }}</td>
                                <td>{{ du.date }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </transition>
        </div>
    </div>
    <modal-loading :id-modal="modal_load_id" :title="modal_load_title" :status-send="status_send"></modal-loading>
</div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import modalLoading from '../modal/modalLoading';
const qs = require('qs');

export default {
    name:'admin-ufv',
    data(){
        return{
            ufv_list:0,
            modal_load_id:'ufv_load',
            modal_load_title:'Registrando',
            status_send:true,
            ufv:{
                value:0,
                date:null
            },
            dts_ufv:[]
        }
    },
    methods:{
        async mListUfv(){
            this.dts_ufv=[];
            // listamos la ufv
            try {
                if(this.ufv_list>0){
                    let ufl = await axios.get(`ufvList/${this.ufv_list}?api_token=${Vue.auth.getToken()}`);
                    console.log(ufl);
                    if(ufl.data.length>0){
                        this.dts_ufv=ufl.data;
                    }
                }else{
                    toastr.warning('Indique un valor de registros a Listar mayor a 0', 'Advertencia');
                }    
            } catch (error) {
                console.log(error)
            }
        },
        mSendUFV(){
            if(this.mValidateUFV()){
            let message = {
                    title: 'Registro UFV',
                    body: `¿Desea Continuar con el Registro de la UFV <b>${this.ufv.value}</b> a fecha <b>${this.ufv.date}</b>?`
                };
                // validar que los datos esten completos
                    let npr=new Promise((resolve, reject)=>{
                        this.$dialog
                        .confirm(message)
                        .then(function(dialog) {
                            resolve(true);          
                        })
                        .catch(function() {
                            resolve(false);
                        });
                    });
                    
                    npr.then(async (msg)=>{
                        try {
                            if(msg){
                                this.mShowModal(this.modal_load_id);
                                // console.info('registramos la ufv');
                                let sendufv=await axios.post(`ufvRegister?api_token=${Vue.auth.getToken()}`, qs.stringify(this.ufv));
                                console.log(sendufv);
                                if(sendufv.data.status){
                                    toastr.success(sendufv.data.response, 'Exito');
                                    this.ufv.date=null;
                                    this.ufv.value=0;
                                }else{
                                    toastr.error(sendufv.data.response, 'Error');
                                }
                            }else{
                                console.error('no se envio la ufv');
                            }    
                        } catch (error) {
                            console.error(error);
                            setTimeout(() => {
                                this.mHideModal(this.modal_load_id);
                            }, 1000);
                        }
                        setTimeout(() => {
                            this.mHideModal(this.modal_load_id);
                        }, 1000);
                    })    
            }else{
                console.error('no se ha enviado datos al servidor');
            }
        },
        mValidateUFV(){            
            if(this.ufv.value===0 || this.ufv.value<0 || this.ufv.value === ''){
                toastr.warning('Indique un valor valido para la UFV', 'Error');
                return false;
            }

            let adin=this.ufv.date.split('T');
            this.ufv.date=adin[0];

            if(this.ufv.date === null || !(this.ufv.date.length === 10)){
                toastr.warning('Indique la Fecha de UFV', 'Error');
                return false;
            }
            // verificar que sea el primero de enero de cada anio
            return true;
        },
        mShowModal(e){
            $(`#${e}`).modal('show');
        },
        mHideModal(e){
            $(`#${e}`).modal('hide');
        }
    },
    components:{
        'modal-loading':modalLoading
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ufv/adminUfv.vue